import { css } from '@sitebase/emotion';
import { sizeBase, lineHeight, colorMonochromeWhite, colorPrimary500, colorPrimary200, colorPrimary100, colorPrimary50, colorGreen500, colorRed500, animationDuration, radiusDefaultSize, fontDefaults } from '../settings';

import { cssSizes } from './helpers';

var _ref2 = ';display:flex;justify-content:space-between;align-items:center;background-color:';
var _ref3 = ';color:';
var _ref4 = ';box-sizing:border-box;line-height:';
var _ref5 = ';padding:';
var _ref6 = ';position:relative;border-radius:2px;border:1px solid ';
var _ref7 = ';';
var _ref8 = ';';
var _ref9 = ';';
var _ref10 = ';&::after{background-color:';
var _ref11 = ';border-radius:0 0 ';
var _ref12 = ' ';
var _ref13 = ';bottom:-1px;content:\'\';display:block;height:3px;position:absolute;left:-1px;transition:width ';
var _ref14 = ',background-color ';
var _ref15 = ';width:0%;will-change:width,background-color;';
var _ref16 = '}';
export var select = function select(_ref) {
  var theme = _ref.theme,
      size = _ref.size,
      status = _ref.status,
      disabled = _ref.disabled,
      open = _ref.open,
      focused = _ref.focused;

  var isLight = theme === 'light';
  var sizeStyles = cssSizes[size];
  return (/*#__PURE__*/css(fontDefaults, _ref2, colorMonochromeWhite, _ref3, colorPrimary200, _ref4, lineHeight, _ref5, sizeBase, _ref6, isLight ? colorPrimary50 : 'transparent', _ref7, sizeStyles, _ref8, open && selectOpened(theme), _ref9, disabled && selectDisabled, _ref10, colorPrimary100, _ref11, radiusDefaultSize, _ref12, radiusDefaultSize, _ref13, animationDuration, _ref14, animationDuration, _ref15, !focused && statuses[status], _ref16)
  );
};

var statuses = {
  error: '\n      width: calc(100% + 2px);\n      background-color: ' + colorRed500 + ';\n  ',
  success: '\n      width: calc(100% + 2px);\n      background-color: ' + colorGreen500 + ';\n  '
};

var _ref17 = 'border-radius:2px 2px 0 0;border-color:';
var _ref18 = ';';
var selectOpened = function selectOpened(theme) {
  var isLight = theme === 'light';
  return (/*#__PURE__*/css(_ref17, isLight ? colorPrimary100 : 'transparent', _ref18)
  );
};

export var selectValue = /*#__PURE__*/css('flex-grow:1;');

export var selectValueSelected = /*#__PURE__*/css('color:', colorPrimary500, ';');

export var selectControl = /*#__PURE__*/css('height:100%;left:0;opacity:0;position:absolute;top:0;width:100%;border:1px solid ', colorPrimary50, ';');

export var selectDisabled = /*#__PURE__*/css('cursor:not-allowed;opacity:0.5;outline:none;& .', selectControl, '{cursor:not-allowed;}');

export var selectControlReadOnly = /*#__PURE__*/css('visibility:hidden;z-index:-1;');